export const billPaymentStatus = function (value) {
  switch (value) {
    case 'reproved':
      return 'Reprovado';
    case 'paid':
      return 'Pago';
    case 'pending':
      return 'Pendente';
    case 'canceled':
      return 'Cancelado';
    case 'chargeback':
      return 'Estornado';
    default:
      return '';
  }
};
